import React, { Fragment } from 'react';

/* section */
import OrderSectionInfo from '../../app-module-order-section-info/default';
import CompanySectionInfo from '../../app-module-company-detail-section-info/default';
import ContactSectionInfo from '../../app-module-company-contacts-detail-section-info/default';
import OrderSectionProduct from '../../app-module-order-section-product/default';
/* section */

const index = ({ order, company, contact, product_card }) => {

  return <Fragment>
    <OrderSectionInfo {...order} />
    <CompanySectionInfo {...company} />
    <ContactSectionInfo {...contact} />
    <OrderSectionProduct {...product_card} />
  </Fragment>

};

export default index;
